if (!customElements.get('rxk-reviews')) {
  const requests = new Map();
  customElements.define('rxk-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.started) { this.titleObserver?.observe(document.querySelector('main') || document.body, {childList:true,subtree:true}); this.mountSummary(); return; }
      this.started = true;
      this.page = 0;
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      const form = this.querySelector('.rxk-reviews__form');
      this.disclosure = this.querySelector('.rxk-reviews__disclosure');
      if (this.querySelector('[data-form-success], .errors')) { form.open = true; this.disclosure.open = true; }
      this.disclosure.addEventListener('toggle',()=>this.summaryLink?.setAttribute('aria-expanded',String(this.disclosure.open)));
      this.load();
    }
    disconnectedCallback() { this.titleObserver?.disconnect(); this.summaryLink?.remove(); }
    mountSummary() {
      if (!this.scoreText || !this.isConnected || this.summaryLink?.isConnected) return;
      const title = document.querySelector('main .rxk-titel');
      if (!title) return;
      const link = document.createElement('a');
      link.className = 'rxk-reviews-title-link';
      link.href = '#'+this.id;
      link.setAttribute('aria-controls',this.disclosure.id);
      link.setAttribute('aria-expanded',String(this.disclosure.open));
      link.setAttribute('aria-label',this.familyTitle+': '+this.scoreText);
      const stars = document.createElement('span');
      stars.className='rxk-reviews__stars';stars.setAttribute('aria-hidden','true');
      const base=document.createElement('span');base.textContent='★★★★★';
      const fill=document.createElement('span');fill.textContent='★★★★★';fill.className='rxk-reviews__stars-fill';
      fill.style.width=(this.average/5*100)+'%';stars.append(base,fill);
      link.append(stars,document.createTextNode(this.scoreText));
      link.addEventListener('click',event=>{
        event.preventDefault();
        this.disclosure.open=true;
        link.setAttribute('aria-expanded','true');
        this.disclosure.querySelector('summary').focus({preventScroll:true});
        this.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
      });
      title.after(link);
      this.summaryLink=link;
    }
    async load() {
      try {
        const url = this.dataset.url;
        if (!requests.has(url)) requests.set(url, fetch(url).then(r => { if (!r.ok) throw Error('Reviews unavailable'); return r.json(); }).catch(e => { requests.delete(url); throw e; }));
        const data = await requests.get(url);
        let group = Object.values(data.groups).find(g => g.products.includes(this.dataset.product));
        try {
          const root = window.Shopify?.routes?.root || '/';
          const endpoint = `${root}apps/roxxlyn-reviews/feed?product_id=${encodeURIComponent(this.dataset.product)}`;
          const response = await fetch(endpoint, {cache:'no-store',signal:AbortSignal.timeout(6000)});
          if (response.ok) {
            const live = await response.json();
            if (live.version===1 && live.products?.includes(this.dataset.product) && Array.isArray(live.reviews) && Array.isArray(live.removedIds)) {
              const removed = new Set(live.removedIds);
              const rows = new Map((group?.reviews || []).filter(r=>!removed.has(r.id)).map(r=>[r.id,r]));
              for (const row of live.reviews) if (!removed.has(row.id) && Number.isInteger(row.rating) && row.rating>=1 && row.rating<=5 && typeof row.text==='string' && /^\d{4}-\d{2}-\d{2}$/.test(row.date)) rows.set(row.id,row);
              group = {...(group || {name:live.name,products:live.products}),reviews:[...rows.values()]};
            }
          }
        } catch { /* Existing imported reviews remain available during outages. */ }
        if (!group?.reviews.length) return;
        this.reviews = group.reviews;
        const number = new Intl.NumberFormat(this.dataset.locale, {maximumFractionDigits:2});
        const average = this.reviews.reduce((sum,r)=>sum+r.rating,0)/this.reviews.length;
        this.average = average;
        this.familyTitle = this.labels.title.replace('[stone]',group.name);
        this.querySelector('[data-title]').textContent = this.classList.contains('rxk-reviews--tab') ? this.labels.count : this.familyTitle;
        this.scoreText = `${number.format(average)} / 5 · ${number.format(this.reviews.length)} ${this.labels.count}`;
        this.querySelector('[data-score]').textContent = this.classList.contains('rxk-reviews--tab') ? `${number.format(average)} \u2605 (${number.format(this.reviews.length)})` : this.scoreText;
        for (const selector of ['[data-rating]','[data-sort]']) this.querySelector(selector).addEventListener('change',()=>{this.page=0;this.render();});
        this.querySelector('[data-prev]').addEventListener('click',()=>{this.page--;this.render();});
        this.querySelector('[data-next]').addEventListener('click',()=>{this.page++;this.render();});
        this.render();
        this.querySelector('.rxk-reviews__content').hidden = false;
        this.mountSummary();
        this.titleObserver=new MutationObserver(()=>this.mountSummary());
        this.titleObserver.observe(document.querySelector('main') || document.body,{childList:true,subtree:true});
      } catch { this.dataset.loadFailed = 'true'; }
    }
    render() {
      const rating = Number(this.querySelector('[data-rating]').value);
      const oldest = this.querySelector('[data-sort]').value === 'oldest';
      const rows = this.reviews.filter(r=>!rating || r.rating===rating).sort((a,b)=>(oldest?1:-1)*a.date.localeCompare(b.date)||a.id.localeCompare(b.id));
      const pageSize = 3;
      const start = this.page*pageSize;
      const list = this.querySelector('[data-list]');
      list.replaceChildren();
      for (const review of rows.slice(start,start+pageSize)) {
        const article=document.createElement('article');
        article.className='rxk-reviews__review';
        const meta=document.createElement('div');meta.className='rxk-reviews__meta';
        const stars=document.createElement('span');stars.textContent='★'.repeat(review.rating)+'☆'.repeat(5-review.rating);stars.setAttribute('aria-label',`${review.rating} / 5`);
        const date=document.createElement('time');date.dateTime=review.date;
        date.textContent=new Intl.DateTimeFormat(this.dataset.locale,{month:'long',year:'numeric',timeZone:'UTC'}).format(new Date(review.date+'T00:00:00Z'));
        meta.append(stars,date);
        const body=document.createElement('p');body.textContent=review.text || this.labels.no_text;
        if(review.language) body.lang=review.language;
        article.append(meta,body);list.append(article);
      }
      if(!rows.length) {const p=document.createElement('p');p.textContent=this.labels.empty;list.append(p);}
      this.querySelector('[data-page]').textContent=rows.length?`${start+1}–${Math.min(start+pageSize,rows.length)} / ${rows.length}`:'0';
      this.querySelector('[data-prev]').disabled=this.page===0;
      this.querySelector('[data-next]').disabled=start+pageSize>=rows.length;
    }
  });
}
